// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1___b1310030b9cff78db8d","cls2":"QuestionStyles-cls2___c8a375bc8928009f277 QuestionStyles-cls1___b1310030b9cff78db8d"};